export default __webpack_public_path__ + "static/media/MeredithLovelace.de70dde4.png";